import {defaultPagination} from "@/services/pagination";
import {
  exportSnapshot,
  listBreadcrumps,
  listMails,
  restoreSnapshot,
  getEmailDetails,
  updateUser,
} from "@/services/api/app/office/recovery/exchange/data-set/mail";
import {listInitialBackupStats} from "@/services/api/app/common/initialBackup";

const defaultState = () => ({
  files: [],
  searchFiles: [],
  searchPagination: {
    ...defaultPagination(),
    sortBy: 'snapshots.create_date_time'
  },
  pagination: {
    ...defaultPagination(),
    sortBy: 'snapshots.create_date_time'
  },
  folderId: null,
  breadcrumps: null,
  search: null,
  initialSearch: null,
  initialBackupStatus: {},
  filterBackupStatus: {
    provider: 1,
    module: 5,
    dataType: 2,
  },
})

export default {
  namespaced: true,

  actions: {
    listSnapshotDetails({commit, state}, data) {
      return listMails({
        ...data,
        pagination: state.pagination,
        folderId: state.folderId
      })
        .then(({result, pagination}) => {
          let index = Date.parse(new Date());
          const res = result.map(file => {
            return {
              ...file,
              originalId: file.id,
              id: index++
            }
          })

          commit('setFiles', res)
          commit('setPagination', pagination)
        })
    },
    searchFiles({commit, state}, data) {
      return listMails(data)
        .then(({result, pagination}) => {
          commit('setSearchFiles', result)
          commit('setSearchPagination', pagination)
          return {result, pagination}
        })
    },
    searchSnapshotDetails({commit, state}, data) {
      return listMails(data)
        .then(({result, pagination}) => {
          commit('setSearchFiles', result)
          commit('setSearchPagination', pagination)
          return {result, pagination}
        })
    },
    listBreadcrumps({state, commit}, {userId, snapshotDate}) {
      if (state.folderId && userId && snapshotDate) {
        return listBreadcrumps({
          userId,
          snapshotDate,
          folderId: state.folderId
        })
          .then(result => {
            commit('setBreadcrumps', result);
          })
      } else {
        commit('setBreadcrumps', []);
        return Promise.resolve();
      }
    },
    exportSnapshot({commit}, data) {
      return exportSnapshot({
        ...data,
        dataType: '2'
      });
    },
    restoreSnapshot({commit}, data) {
      return restoreSnapshot(data);
    },
    getEmailDetails({commit, state}, id) {
      return getEmailDetails(id)
    },
    updateUser({commit, state}, data) {
      return updateUser(data)
    },
    listInitialBackupStats({commit, state}, filter) {
      return listInitialBackupStats({
        ...state.filterBackupStatus,
        id: filter.id,
      })
        .then((result) => {
          commit('setInitialBackupStatus', result)
          return result;
        })
    },
  },

  mutations: {
    setFiles(state, files) {
      state.files = files;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    setSearchFiles(state, files) {
      state.searchFiles = files;
    },
    setSearchPagination(state, pagination) {
      state.searchPagination = pagination;
    },
    resetSearchPagination(state) {
      state.searchPagination = {
        ...defaultPagination(),
        sortBy: 'snapshots.create_date_time'
      };
    },
    setFolderId(state, folderId) {
      state.folderId = folderId;
    },
    setSearch(state, search) {
      state.search = search;
    },
    setBreadcrumps(state, breadcrumps) {
      state.breadcrumps = breadcrumps;
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
    setInitialSearch(state, initialSearch) {
      state.initialSearch = initialSearch
    },
    setInitialBackupStatus(state, initialBackupStatus) {
      state.initialBackupStatus = initialBackupStatus
    },
  },

  state: defaultState()
}
